import { Backdrop, CircularProgress } from '@material-ui/core'
import { useEffect } from 'react'
import { useLoadingState } from '../store/loadingState'


const Loading: React.FC = () => {
  const [loading, setLoading] = useLoadingState()

  // 超时5s关闭loading
  useEffect(()=>{
    const timer = setTimeout(() => {
      setLoading(false)
    }, 5000)

    return ()=>clearTimeout(timer)
  }, [loading, setLoading])

  return(
    <Backdrop style={{zIndex: 1002}} invisible open={loading}>
      
      <CircularProgress color='primary'></CircularProgress>
    
    </Backdrop>
  )
}

export default Loading
